const afterSaleCommentsRouter = [{
  path: 'afterSaleComment',
  name: 'afterSaleComment',
  component: resolve => require(['@views/afterSaleComment/afterSaleComment'], resolve),
  meta: {
    title: '评价'
  }
}, {
  path: 'asl',
  name: 'asl',
  component: resolve => require(['@views/afterSaleComment/afterSaleLogin'], resolve),
  meta: {
    title: '评价登录'
  }
}]

export default afterSaleCommentsRouter;



// WEBPACK FOOTER //
// ./src/router/afterSaleComment/index.js